import { render } from "./user-type.vue?vue&type=template&id=fbd98c0c"
import script from "./user-type.vue?vue&type=script&lang=js"
export * from "./user-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__